import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import TourMapStage from './tour-map-stage';
// The homes on the tour page's map: tapping a pin floats its home's card over the map, as on the map page.
const TourHomesMap = (props) => {
    var _a;
    const [selectedId, setSelectedId] = useState(null);
    const stageRef = useRef(null);
    const cardRef = useRef(null);
    return (_jsx(TourMapStage, { tourId: props.tourId, previewing: props.previewing, homes: props.homes, shown: props.homes, visited: props.visited, selected: (_a = props.homes.find(h => h.id === selectedId)) !== null && _a !== void 0 ? _a : null, onSelect: setSelectedId, stageRef: stageRef, cardRef: cardRef }));
};
export default TourHomesMap;
